var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.disabled ? 'span' : 'router-link',{tag:"component",attrs:{"to":{ name: 'associations-history', query: _vm.query },"rel":"nofollow"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }